import {
  faBan,
  faCalendarDays,
  faCircleCheck,
  faCircleXmark,
  faCoins,
  faHourglassHalf,
  faPauseCircle,
  faPenToSquare,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

// Flip `disabled` back to false to re-enable editing chases from the row menu.
export const chaseTableActions = [
  {
    name: "Edit Chase",
    icon: faPenToSquare,
    disabled: true,
  },
];

export const chaseHeadingData = [
  {
    header: "CUSTOMER NAME",
    accessor: "customerName",
  },
  {
    header: "CONTACT DETAILS",
    accessor: "contactDetails",
  },
  {
    header: "DATES",
    accessor: "type",
  },
  {
    header: "CHASE TYPE",
    accessor: "insurer",
  },
  {
    header: "REMAINING",
    accessor: "",
  },
  {
    header: "",
    accessor: "driver",
  },
  {
    header: "STATUS",
    accessor: "status",
  },
  {
    header: "ACTIONS",
    accessor: "actions",
  },
];

export const branddata = [
  {
    name: "BCD",
    label: "Bike Compare Direct",
  },
  {
    name: "BI",
    label: "Bike Insurance UK",
  },
  {
    name: "CCD",
    label: "Car Compare Direct",
  },
  {
    name: "CLD",
    label: "Car LineDirect",
  },
  {
    name: "BizC",
    label: "Business Compare (Courier)",
  },
  {
    name: "BizC-OGI",
    label: "Business Compare (OGI)",
  },
  {
    name: "BizC-Acturis",
    label: "Business Compare (Acturis)",
  },
  {
    name: "VLD",
    label: "Van LineDirect",
  },
  {
    name: "VCD",
    label: "VanCompare Direct",
  },
  {
    name: "VIUK",
    label: "Van Insurance UK",
  },
  {
    name: "MYB",
    label: "Mind Your Business",
  },
];

export const brandCodes = [
  { value: "BICX", label: "VanInsurance.co.uk" },
  { value: "BIKI", label: "BikeInsurance.co.uk" },
  { value: "BCOM", label: "BikeCompareDirect" },
  { value: "BLD", label: "BikelineDirect" },
  { value: "BUSC", label: "BusinessCompare" },
  { value: "BACT", label: "BusinessCompare(Acturis)" },
  { value: "BOGI", label: "BusinessCompare(OGI)" },
  { value: "CARI", label: "CarInsurance.co.uk" },
  { value: "CCOM", label: "CarCompareDirect" },
  { value: "CCOT", label: "CarCompareDirect" },
  { value: "CLD", label: "CarlineDirect" },
  { value: "CLDT", label: "CarlineDirect" },
  { value: "CLDX", label: "CarlineDirect" },
  { value: "CRC", label: "CourierCompare" },
  { value: "CRCT", label: "CourierCompare" },
  { value: "CVAI", label: "VanInsurance.co.uk" },
  { value: "CVCT", label: "VanCompareDirect" },
  { value: "CVLT", label: "VanlineDirect" },
  { value: "HCOM", label: "HomeCompareDirect" },
  { value: "HLD", label: "HomelineDirect" },
  { value: "MYB", label: "MindYourBusiness" },
  { value: "NCAR", label: "CarCompareDirect" },
  { value: "NCLD", label: "CarlineDirect" },
  { value: "NCOM", label: "VanCompareDirect" },
  { value: "NVAI", label: "VanInsurance.co.uk" },
  { value: "NVLD", label: "VanlineDirect" },
  { value: "SBIZ", label: "SimplyBusiness" },
  { value: "VANI", label: "VanInsurance.co.uk" },
  { value: "VANL", label: "VanInsurance.co.uk" },
  { value: "VANT", label: "VanInsurance.co.uk" },
  { value: "VCOL", label: "VanCompareDirect" },
  { value: "VCOM", label: "VanCompareDirect" },
  { value: "VCOT", label: "VanCompareDirect" },
  { value: "VICC", label: "VanInsurance.co.uk" },
  { value: "VICN", label: "VanInsurance.co.uk" },
  { value: "VICX", label: "VanInsurance.co.uk" },
  { value: "VLD", label: "VanlineDirect" },
  { value: "VLDC", label: "VanlineDirect" },
  { value: "VLDT", label: "VanlineDirect" },
  { value: "VLDV", label: "VanlineDirect" },
  { value: "VLDW", label: "VanlineDirect" },
  { value: "VLDX", label: "VanlineDirect" },
];

export type LoanStatus = {
  name: string;
  bgColor: string;
  icon: IconDefinition;
  color: string;
};

// One hue and one icon per state — no two statuses share either, so a row is
// readable at a glance without reading the label.
export const loanStatusData: LoanStatus[] = [
  {
    name: "Cancelled",
    bgColor: "bg-red-50 dark:bg-red-500/15",
    icon: faBan,
    color: "text-red-700 dark:text-red-300",
  },
  {
    name: "Pending-Cancellation",
    bgColor: "bg-pink-50 dark:bg-pink-500/15",
    icon: faTriangleExclamation,
    color: "text-pink-700 dark:text-pink-300",
  },
  {
    name: "Failed",
    bgColor: "bg-orange-50 dark:bg-orange-500/15",
    icon: faCircleXmark,
    color: "text-orange-700 dark:text-orange-300",
  },
  {
    name: "Collected",
    bgColor: "bg-emerald-50 dark:bg-emerald-500/15",
    icon: faCircleCheck,
    color: "text-emerald-700 dark:text-emerald-300",
  },
  {
    name: "Awaiting-Customer",
    bgColor: "bg-slate-100 dark:bg-slate-400/15",
    icon: faHourglassHalf,
    color: "text-slate-600 dark:text-slate-300",
  },
  {
    name: "On-Hold",
    bgColor: "bg-blue-50 dark:bg-blue-500/15",
    icon: faPauseCircle,
    color: "text-blue-700 dark:text-blue-300",
  },
];

export const enhancedloanStatusData: LoanStatus[] = [
  ...loanStatusData,
  {
    name: "Plan",
    bgColor: "bg-violet-50 dark:bg-violet-500/15",
    icon: faCalendarDays,
    color: "text-violet-700 dark:text-violet-300",
  },
  {
    name: "Partial",
    bgColor: "bg-amber-50 dark:bg-amber-500/15",
    icon: faCoins,
    color: "text-amber-700 dark:text-amber-300",
  },
];

export const ChaseInputTypeData = [
  {
    id: "nationalInsuranceNumber",
    label: "National Insurance Number",
  },
  {
    id: "driversLicenceNumber",
    label: "Drivers License Number",
  },
  {
    id: "postCode",
    label: "Post Code",
  },
];
